module.exports = "<div *ngFor=\"let panel of childPanelList\" class=\"row panel\" [ngClass]=\"{special: panel.title ==='Personalized for you'}\" >\n  <div class=\"col-md-5 text\">\n    <h3><strong>{{panel.title}}</strong></h3>\n    <p>{{panel.detail}}</p>\n    <a href=\"#\">Learn More</a>\n  </div>\n  <div class=\"cold-md-7 picture\">\n    <img class=\"panel-img\" alt=\"Panel Picture\" src={{panel.img}}>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/panel/panel.component.html
// module id = ../../../../../src/app/panel/panel.component.html
// module chunks = main